import styled, { keyframes } from "styled-components";

const showHide = keyframes`
    0% {
          opacity: 0;
      }
    100% {
          opacity: 1;
      }
`;

export const StyledGrandDiv = styled.div`
  height: 100vh;
  min-height: 600px;
  max-width: ${({ hideMenu }) => (hideMenu ? "113px" : "285px")};
  min-width: ${({ hideMenu }) => (hideMenu ? "113px" : "285px")};

  background: #585e66;
  position: relative;
  transition: 0.4s ease-out;
`;

export const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 27px;
  transition: 0.4s ease-out;
  user-select: none;
  height: 100%;
`;

export const DivSeparator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const StyledDiv2 = styled.div`
  height: 37px;
`;

export const StyledButton = styled.div`
  position: absolute;
  right: -23px;
  top: 26px;

  transition: 0.4s ease-out;

  svg {
    transform: ${({ hideMenu }) =>
      hideMenu ? "rotate(0deg)" : "rotate(180deg)"};
    transition: 0.4s ease-out;
  }
`;

export const FadeEffect = styled.div`
  @media (prefers-reduced-motion: no-preference) {
    animation-name: ${showHide};
    animation-fill-mode: backwards;
  }
`;

export const Content = styled.div`
  margin-top: 8vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

export const StyledText = styled.div`
  width: 95.89%;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: ${({ actived }) => (actived ? "#40E5A0" : "#7e858f")};
  line-height: 23px;
  user-select: none;
  cursor: pointer;
  margin-bottom: 0px; //26px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  font-weight: ${({ actived }) => (actived ? "600" : "normal")};

  path {
    stroke: ${({ actived }) => (actived ? "#40E5A0" : "#7e858f")};
  }

  background: ${({ actived }) =>
    actived
      ? "linear-gradient(270.16deg, rgba(64, 229, 160, 0.34) 0.14%, rgba(66, 70, 76, 0) 160.14%)  "
      : "none"};
  border-radius: ${({ actived }) => (actived ? "4.2339px" : "none")};
  height: 43px;

  &:hover {
    color: ${({ actived }) => (actived ? "#40E5A0" : "#d4d6da")};

    path {
      stroke: ${({ actived }) => (actived ? "#40E5A0" : "#d4d6da")};
    }
  }
`;

export const StyledDiv3 = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ hideMenu }) => (hideMenu ? "center" : "flex-start")};
  width: 75.88%;
`;

export const ShortDiv = styled.div`
  margin: 0 0 0 0;
  position: absolute;
  border-right: 3.95164px solid #40e5a0;
  height: 43px;
  left: 0%;
  border-radius: 10px;
  width: 0.1px;
`;

export const ShortDiv2 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 43px;
`;

export const AuxDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Footer = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;

export const FooterText = styled.div`
  color: #a9aeb4;
  font-size: 15px;
  line-height: 19px;
  margin-bottom: 18px;
`;

export const ProgressBar = styled.div`
  background: #7e858f;
  border-radius: 13px;
  width: 64%;
  height: 13px;
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;

export const ProgressText = styled.div`
  font-weight: 600;
  font-size: 11px;
  line-height: 14px;
  color: #ffffff;
  z-index: 1;
`;

export const GreenProgress = styled.div`
  background: #40e5a0;
  border-radius: 13px;
  width: ${({ percentage }) => percentage};
  height: 13px;
  position: absolute;
  left: 0;
`;

export const SizeText = styled.div`
  font-size: 14px;
  line-height: 19px;
  color: #eff1f5;
  margin-top: 15px;
`;
export const ButtonDiv = styled.div`
  margin-top: 35px;
  height: 40px;
`;
